module.exports = __webpack_public_path__ + "static/media/ciel4.6732ac9d.png";